import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getTypes.operation = 'READ';
getTypes.idFrom = () => 'auditLogTypes'; // stable resource
export function getTypes() {
    return get(`${API_URL}/audit-record/types`);
}
